import { connect } from "react-redux";
import WorkflowsComponent from "../../Components/Workflows/WorkflowsComponent";
import { setWorkflows } from "../../Redux/Actions/VariablesWorkflowsActions";

const mapStateToProps = (state) => ({
  SCOPES_NAMES: state.reducer.SCOPES_NAMES,
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  WORKFLOWS: state.reducer.WORKFLOWS,
});

const mapDispatchToProps = (dispatch) => ({
  setWorkflows: (workflows) => dispatch(setWorkflows(workflows)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowsComponent);
